module.exports = __webpack_public_path__ + "img/bell-regular.c1bedbfe.svg";